<!-- Main -->
<div id="main" class="wrapper style1">
    <div class="container">
      <div class="logo-center">
        <div>
          <img src="./assets/images/thepeopleswrites-logo.jpg" alt="" />
          <h3>September 2021</h3>
        </div>
      </div>
      <header class="major" id="dorothee18">
        <h2>Dorothee in the 18th Century.....I Got A Story To Tell....From Time</h2>
        <p>Audio Drama</p>
      </header>
  
      <!-- Content -->
      <section id="content">
        <a href="#" class="image fit"
          ><img src="./assets/images/slave-woman-in-Britain.jpg" alt=""
        /></a>
        <h3>Play your Part</h3>
        <ul>
          <li>
            <strong>Advocate</strong> - by  telling your friend to tell a friend about our project.  Share our work on your social media.
          </li>
          <li>
            <strong>Donate</strong> -  towards our live stream of a live performance of these poignant narratives. Insert Go Fund me link from SACCO.
          </li>
          <li>
            <strong>Participate</strong> by attending the Performance at Charles Cryer Theatre October 23rd
          </li>
        </ul>
        <div class="logo-center">
          <div>
            <img src="./assets/images/thepeopleswrites-logo.jpg" alt="" />
          </div>
        </div>
      </section>
    </div>
    <div class="container">
      <hr />
      <header class="major" id="dorothee20">
        <h2>Dorothee in the 20the Century ..... Still Moving</h2>
        <p>Pictorial Drama</p>
        <p>
          A 10 minute photo film about the Windrush generation and their
          settlement in post WW2 Britain.
        </p>
      </header>
  
      <!-- Content -->
      <section id="content">
        <a href="#" class="image fit"
          ><img src="./assets/images/dorothee.jpg" alt=""
        /></a>
        <h3> Play your Part</h3>
        <ul>
          <li>
            <strong>Advocate</strong> - by  telling your friend to tell a friend about our project.  Share our work on your social media.
          </li>
          <li>
            <strong>Donate</strong> - your own, family members or friends anecdotes, memories, stories of life in the UK, Caribbean, Africa, India or Pakistan from 1948-1971 . Please share old photos and film of life during the post War period. We will digitally scan and return your old photos so you can  share them with family and friends.
          </li>
          <li>
            <strong>Participate</strong> follow us online, read the books, engage
            in informed discussions, attend live performances.
          </li>
        </ul>
        <div class="logo-center">
          <div>
            <img src="./assets/images/thepeopleswrites-logo.jpg" alt="" />
          </div>
        </div>
      </section>
    </div>
  </div>
  